/**
 * @ngdoc directive
 * @name WebCoreModule.directive:required
 * @restrict A
 * @element input|select|textarea
 * @description
 * The required directive adds behavior to HTML's required attribute. With this directive in use, any tag with a
 * required attribute will have a required field indicator added to the label for the field. The directive will also
 * add an appropriate legend to the form of the field, indicating what the required field indicator means.
 */

angular.module('WebCoreModule')
    .directive('required', ['WcTranslateConfiguratorService', '$compile', '$timeout', function (WcTranslateConfiguratorService, $compile, $timeout) {
        return {
            restrict: 'A',
            require: ['required'],
            controller: ['$scope', '$element', '$attrs', 'WcTranslateConfiguratorService', function ($scope, $element, $attrs, WcTranslateConfiguratorService) { // jshint ignore:line

                WcTranslateConfiguratorService.loadPartAndRefresh('WC-dataTable');

                // Look for the label to insert the required abbreviation
                this.insertionPoint = $('label[for="' + $attrs.id + '"]');
                // If it's a radio or checkbox, try to find legend for fieldset instead
                if ($element[0].type == 'checkbox' || $element[0].type == 'radio') {
                    this.insertionPoint = $element.closest('fieldset').find('legend');
                }


                // Look for the parent form to insert the required legend
                this.formElem = this.insertionPoint.closest('form');


                this.addLabels = function (scope, attrs) {

                    WcTranslateConfiguratorService.loadPartAndRefresh('WC-required');
                    $timeout(angular.bind(this, function () {
                        // check to make sure abbr is not already there before adding
                        if (this.insertionPoint.has('abbr[title="Required"]').length === 0 && !attrs.disabled && !attrs.readonly) {
                            this.insertionPoint.prepend('<abbr class="required h6" title="Required">*</abbr>');
                        }

                         // Responsive table - row selection required
                        if ($element[0].hasAttribute('wc-responsive-table')) {
                            this.formGroup = $element.closest('form').find('.form-group').first();
                            this.formGroup.prepend($compile('<div><abbr class="required h6" title="Required">*</abbr> <span>{{"tableSelectionRequired" | translate}}</span></div>')($scope));
                            this.formElem = $element.closest('form');
                        }

                        //lastly, check for the form legend and add it if necessary
                        if ((this.formElem.has('div.required-legend').length === 0 && !attrs.disabled && !attrs.readonly) || ($element[0].hasAttribute('wc-responsive-table'))) {
                            this.formElem.prepend($compile('<div class="required-legend hidden-xs"><span class="required-text"><abbr class="required h6" title="Required">*</abbr> {{"required.requiredText" | translate}}</span></div>')(scope));
                        }
                    }), 100);
                };

            }],
            link: function (scope, elem, attrs, ctrls) {
                var requiredController = ctrls[0];

                requiredController.addLabels(scope, attrs);
            }
        };
    }]);